/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import CreateModal from '../../CreateModal'

import { useNavigate, useParams } from 'react-router-dom'
export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  console.log(list, "listlist")
  const [loader, setLoader] = useState(true)
  const [category, setCategory] = useState([])
  const {page_id} = useParams()
  console.log(page_id, "page_idpage_id") 
  const getAppTypes = async () => {
    const { response } = await AppService.award_ranking.filter({
      query: `category=${page_id}`,
      toaster: false,
    })
    if (response) {
      setList(response?.data)
    } else {
      setList([])
    }
    setLoader(false)
  }
  const getCategory = async () => {
    const { response } = await AppService.award_ranking_category.get({
      toaster: false,
    })
    if (response) {
      setCategory(response.data)
    } else {
      setCategory([])
    }
    setLoader(false)
  }

  const onLoad = () => {
    getAppTypes()
    getCategory()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.award_ranking.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  return {
    loader: loader,
    category,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },

        { Header: 'category', accessor: 'category' },
        { Header: 'rank', accessor: 'rank' },
        { Header: 'image', accessor: 'image' },
        { Header: 'Points Number', accessor: 'points' },


        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        name: data?.name,

        category: data?.category.name,
        rank: data?.rank,
        image: data?.image,
        points: data?.points,


        action: (
          <MDBox>
            <EditModal data={data} handleRefresh={onLoad} category={category} />
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
